import styled from "styled-components";

export const LogoStyle = styled.div`
  font-family: "Fira_Sans600";
  font-style: normal;
  font-weight: 600;
  font-size: 28px;
  line-height: 38px;
  text-transform: uppercase;
`;
